import { FC } from 'react';
import { SurveyResults } from 'containers/surveys';
import { SurveyResultsLayout } from 'pages/atoms';

const SurveyResultsPage: FC = () => {
  return (
    <SurveyResultsLayout>
      <SurveyResults />
    </SurveyResultsLayout>
  );
};

export default SurveyResultsPage;
